/** @format */

import { useEffect } from "react";
import { type CTAId, useCTAStore } from "@/stores/ctaStore";

/**
 * Register a CTA with the coordination store and return whether it's active.
 *
 * Each CTA component determines its own eligibility, then calls this hook.
 * The store picks the highest-priority eligible CTA as the active one.
 */
export function useCTAEligibility(id: CTAId, isEligible: boolean): boolean {
  const register = useCTAStore(s => s.register);
  const unregister = useCTAStore(s => s.unregister);
  const isActive = useCTAStore(s => s.activeCTA === id);

  useEffect(() => {
    if (isEligible) {
      register(id);
    } else {
      unregister(id);
    }
    return () => unregister(id);
  }, [id, isEligible, register, unregister]);

  return isActive;
}
